import { ROLES, FINANCIAL_POSITION } from '../../utils/constants';

export default {
  computed: {
    financialSummaryLoading() {
      return this.$store.getters[FINANCIAL_POSITION.LOADING];
    },
    financialSummaryItems() {
      return this.$store.getters[FINANCIAL_POSITION.GET_SUMMARY];
    },
  },
  data() {
    return {
      financialSummaryError: false,
    };
  },
  methods: {
    async getFinancialSummary() {
      try {
        if (this.user.userRole !== ROLES.CLIENT_ROLE) return;
        if (this.financialSummaryLoading) return;
        this.financialSummaryError = false;

        const contract = this.selectedUnit.contracts.find((o) => o.isValid);
        this.$store.dispatch(FINANCIAL_POSITION.FETCH_POSITION, { contract });
      } catch (err) {
        this.financialSummaryError = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modules/financialSummary.js